// client/src/routes/app/owner-tenancy.tsx — SCR-OAT-001 · OAT-003 (04 §8.15).
//
// Replaces UI-003's `PlaceholderScreen`, which named this item as its owner.
//
// ONE FILE, ONE ROUTE. 04 §8.15 gives „Chiriaș la rândul meu" a single URL and calls it a
// single-screen module, so the tabs of its DETAIL-TABS template are search params rather than
// child routes (D-1190). The route owns the URL state and nothing else: `validateSearch` runs
// the §9.2.3 schema and the screen reads it back typed, so a rental, a tab, a month and a
// filtered personal ledger are all shareable, survive a refresh, and Back is an undo.
//
// `owner` is UI-003's guard and stays. §6.2 calls it „the only role gate" in the app: this is
// the landlord's OWN tenancy, so it is scoped by who the person is rather than by a permission
// anyone could be granted. The sidebar hides the entry, and this renders SCR-SYS-403 for the URL
// that was typed anyway (§9.2.2). Inside the section the two write codes are mirrored as well —
// `Portfolio.Write` for the rental, `Expenses.Write` for its costs — because the seeded
// permissions of a role are a seed, not a law of nature.

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequireRole } from '@/components/layout/route-guards';
import { OwnerTenancySection } from '@/features/owner-tenancy/OwnerTenancySection';
import {
  ownerTenancySearchSchema,
  type OwnerTenancySearch,
} from '@/features/owner-tenancy/search';

export const Route = createFileRoute('/app/owner-tenancy')({
  validateSearch: ownerTenancySearchSchema,
  component: OwnerTenancyScreen,
});

function OwnerTenancyScreen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequireRole role="owner">
      <OwnerTenancySection
        search={search}
        onSearchChange={(next: (previous: OwnerTenancySearch) => OwnerTenancySearch) => {
          void navigate({ search: next });
        }}
      />
    </RequireRole>
  );
}
